export default `
    <div id="#= data.id #" class="label-group-container #= data.containerClasses || ""# #=data.bsc||""# # if (data.disabled) { # disabled # } #">
        <div class="label-group-header-row">
            <div class="col-xs-10 no-pad">
                <a id="#= data.linkId #" style="padding-top:10px;" 
                    class="link bind-label #= data.linkClasses || "" # # if (data.disabled) { # disabled # } #" 
                     data-label-for-id="#= data.id #" 
                    # if (data.headerLabelBind) { # data-bind="#= data.headerLabelBind #" # } # 
                    # if (data.toolTip) { # title="#= data.toolTip #" # } #
                    # if (data.href) { # href="#= data.href #" # } #
                    # if (data.disabled) { # disabled="disabled" # } #
                >
                </a>
            </div>
            <div class="col-xs-2 no-pad">
                <a id="#= data.iconId #" class="pane-body-icon z-icon #= data.iconType # #= data.iconClasses # # if (data.disabled) { # disabled # } #">
                # if (data.iconType == 'tech' || data.iconType == 'small-tech') { #
                    <i class="fas tech-badge"></i>
                # } #
                </a>
            </div>
        </div>
        <div class="label-group-contents # if (data.disabled) { # disabled # } #">
            #= data.components #
        </div>
    </div>
`;
